type Maybe<TObject> = TObject | null | undefined;

export function removeUndefinedEntries<TObject>(
  values: Maybe<TObject>[]
): TObject[] {
  const isDefined = (x: Maybe<TObject>): x is TObject =>
    x !== null && x !== undefined;
  return values.filter(isDefined);
}
